var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal-show",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('closeModal')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }